import { render } from "./AccountWorkspaces.vue?vue&type=template&id=99ea62dc&scoped=true"
import script from "./AccountWorkspaces.vue?vue&type=script&lang=js"
export * from "./AccountWorkspaces.vue?vue&type=script&lang=js"

import "./AccountWorkspaces.vue?vue&type=style&index=0&id=99ea62dc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-99ea62dc"

export default script